const { Component, DOMUtils, Utils } = window.Liftoff;

class Tiler {
  constructor({
    tileElement,
    minColumnCount = 1,
    maxColumnCount = 20,
    targetWidth,
    minRowCount = 1,
    maxRowCount = 20,
    targetHeight,
  }) {
    const { width, height } = tileElement.getBoundingClientRect();
    const rowCount = Math.ceil(
      Utils.clamp(targetHeight / height, minRowCount, maxRowCount)
    );
    const columnCount = Math.ceil(
      Utils.clamp(targetWidth / width, minColumnCount, maxColumnCount)
    );

    this.element = DOMUtils.createElement({
      classList: ["tiler"],
      children: Utils.range(0, rowCount).map(() => {
        return {
          classList: ["tiler-row"],
          children: Utils.range(0, columnCount).map(() => {
            return {
              style: { width: `${width}px`, height: `${height}px` },
              classList: ["tiler-cell"],
              children: [tileElement.cloneNode(true)],
            };
          }),
        };
      }),
    });
  }

  getElement() {
    return this.element;
  }
}

Component.register(
  "panning",
  class Panning extends Component {
    constructor(config) {
      super(config);

      Utils.assignWithDefaults(
        this,
        {
          speed: 10,
          direction: "left",
          images: [],
        },
        this.config
      );

      this.images = this.images
        .filter(({ image }) => !!image)
        .map(({ image }) => image);
      this.animating = this.ready = false;
    }

    load() {
      this.imagesPromises = Promise.all(
        this.images.map((image) => Utils.loadImage(image))
      );

      return this.imagesPromises;
    }

    layout(parentNode) {
      super.layout(parentNode);

      this.imageSliderEl = DOMUtils.createElement({
        classList: ["image-slider"],
      });

      this.el = DOMUtils.createElement({
        classList: ["panning"],
        children: [this.imageSliderEl],
      });

      this.parentNode.appendChild(this.el);

      this.addEventListeners();

      const { width: visibleWidth, height: visibleHeight } =
        this.el.getBoundingClientRect();

      this.imagesPromises.then((imageEls) => {
        // If there are no images, `this.ready` will never be set to true.
        // In the event that the images can be set via coordination, this
        // logic should be pulled out into its own method.
        if (imageEls.length === 0) return;

        const imageSetTemplateEl = DOMUtils.createElement({
          classList: ["image-set"],
          children: imageEls,
        });

        this.imageSliderEl.appendChild(imageSetTemplateEl);

        const isVertical = ["up", "down"].includes(this.direction);

        const scrollSize = isVertical
          ? imageSetTemplateEl.getBoundingClientRect().height
          : imageSetTemplateEl.getBoundingClientRect().width;

        const visibleSize = isVertical ? visibleHeight : visibleWidth;

        const keyframeTransforms = isVertical
          ? [`translate3d(0, ${-scrollSize}px, 0)`, null]
          : [`translate3d(${-scrollSize}px, 0, 0)`, null];
        if (["up", "left"].includes(this.direction)) {
          [this.finalTransform, this.initialTransform] = keyframeTransforms;
        } else {
          [this.initialTransform, this.finalTransform] = keyframeTransforms;
        }

        // The speed is the percent of the container width covered in 1 second.
        const duration = scrollSize / visibleSize / (this.speed / 100);
        this.transition = `transform linear ${duration}s`;

        this.imageSetTiler = new Tiler({
          tileElement: imageSetTemplateEl,
          minColumnCount: isVertical ? 1 : 2,
          targetWidth: visibleWidth * (isVertical ? 1 : 2),
          minRowCount: isVertical ? 2 : 1,
          targetHeight: visibleHeight * (isVertical ? 2 : 1),
        });

        imageSetTemplateEl.remove();

        this.imageSliderEl.appendChild(this.imageSetTiler.getElement());

        this.ready = true;
        this.pan();
      });
    }

    addEventListeners() {
      this.imageSliderEl.addEventListener("transitionend", () => {
        this.pan();
      });
    }

    resize() {}

    start() {
      this.animating = true;
      this.pan();
    }

    stop() {
      this.animating = false;
      this.resetPanner();
    }

    restart() {
      this.stop();
      this.start();
    }

    resetPanner() {
      Object.assign(this.imageSliderEl.style, {
        transform: this.initialTransform,
        transition: null,
      });

      DOMUtils.forceReflow(this.el);
    }

    pan() {
      if (!(this.ready && this.animating)) return;

      this.resetPanner();

      Object.assign(this.imageSliderEl.style, {
        transform: this.finalTransform,
        transition: this.transition,
      });
    }
  }
);



// WEBPACK FOOTER //
// ./components/panning/panning.js